export const UNICO_CONSTANTS = {
    STORAGE: '@nav/biometryData',
    PARAMETROS: {
        VALIDATION: 'validation',
        REDIRECT_TO: 'redirectTo',
    },
    VALOR_PARAMETROS: {
        BIOMETRY: 'biometry',
    },
    STATUS: {
        SUCCESS: 'PROCESS_RESULT_OK',
    },
    ORIGIN: {
        OTP: 'otp',
        RECOVER: 'recover',
    },
    ORIGIN_VALUE: {
        OTP: 'Login OTP',
        RECOVER: 'Reset de senha',
        DEFAULT: 'Cadastro',
    },
    RECOVER_PASSWORD_STEP: '/recuperar-senha?step=2',
    REDIRECT_HOME: '/plataforma/inicio',
    CHECK_BIOMETRY_LIMIT: {
        LIMIT_EXCEEDED: 'LIMIT_EXCEEDED',
        LIMIT_NOT_EXCEEDED: 'LIMIT_NOT_EXCEEDED',
    },
}
